import { useState } from "react";
import Sidebar from "../../components/feature/Sidebar";
import TopBar from "../../components/feature/TopBar";
import ToxicClauseDetector from "./components/ToxicClauseDetector";
import ContractDrafter from "./components/ContractDrafter";
import CopyrightRegistry from "./components/CopyrightRegistry";

type Tab = "detector" | "drafter" | "copyright";

export default function LegalPage() {
  const [activeTab, setActiveTab] = useState<Tab>("detector");

  const tabs: { id: Tab; label: string; icon: string; badge?: number }[] = [
    { id: "detector", label: "독소조항 탐지", icon: "ri-search-eye-line", badge: 1 },
    { id: "drafter", label: "계약서 드래프팅", icon: "ri-file-edit-line" },
    { id: "copyright", label: "저작권 등록", icon: "ri-copyright-line" },
  ];

  return (
    <div className="min-h-screen bg-[#0C0C0E] flex font-sans">
      <Sidebar />
      <div className="flex-1 ml-56 flex flex-col">
        <TopBar />
        <main className="flex-1 p-5">
          {/* Header */}
          <div className="bg-[#111112] border border-white/[0.06] rounded-xl px-5 py-4 flex items-center justify-between mb-5">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#4B6CF7]/10 border border-[#4B6CF7]/20">
                <i className="ri-scales-3-line text-[#7A9BFF] text-lg"></i>
              </div>
              <div>
                <h1 className="text-[#F2F2F2] font-semibold text-sm">법무 & IP 관리</h1>
                <p className="text-[#444444] text-xs">계약서 검토 · 독소조항 탐지 · 저작권 등록 및 수익 집계</p>
              </div>
            </div>
            <div className="bg-white/[0.03] border border-white/[0.06] rounded-lg px-4 py-2 text-right">
              <div className="text-[#555555] text-xs">검토 대기 계약서</div>
              <div className="text-[#F2F2F2] font-semibold text-base">1건</div>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex items-center gap-0.5 mb-5 bg-white/[0.03] rounded-xl p-1 w-fit border border-white/[0.05]">
            {tabs.map(tab => (
              <button key={tab.id} type="button" onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id ? "bg-[#4B6CF7]/15 text-[#7A9BFF] border border-[#4B6CF7]/20" : "text-[#444444] hover:text-[#888888]"
                }`}>
                <i className={`${tab.icon} text-sm`}></i>
                {tab.label}
                {tab.badge && <span className="bg-[#4B6CF7]/20 text-[#7A9BFF] text-[9px] font-bold w-4 h-4 flex items-center justify-center rounded-full">{tab.badge}</span>}
              </button>
            ))}
          </div>

          {activeTab === "detector" && <ToxicClauseDetector />}
          {activeTab === "drafter" && <ContractDrafter />}
          {activeTab === "copyright" && <CopyrightRegistry />}
        </main>
      </div>
    </div>
  );
}
